/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const LegalForm = {
    GmbhCoKg: 'GMBH_CO_KG',
    Gmbh: 'GMBH',
    Kg: 'KG',
    Ag: 'AG',
    Gbr: 'GBR',
    SoleProprietorship: 'SOLE_PROPRIETORSHIP',
    RegisteredAssociation: 'REGISTERED_ASSOCIATION',
    Foundation: 'FOUNDATION',
    Other: 'OTHER',
    RegisteredMerchant: 'REGISTERED_MERCHANT',
    Freelancer: 'FREELANCER',
    Ug: 'UG',
    Mbb: 'MBB',
    Ohg: 'OHG',
    Eg: 'EG',
    Se: 'SE',
    Municipality: 'MUNICIPALITY',
    Aor: 'AOR',
    Egbr: 'EGBR'
} as const;

export type LegalForm = typeof LegalForm[keyof typeof LegalForm];



